import CustomDialogBox from '@app/components/shared/dialog.component';
import * as models from '@app/models/index';
import Injector from '@app/services';
import { IntlService } from '@app/services/intl.service';
import { TextField, Typography } from '@material-ui/core';
import { Field, Form, Formik, FormikProps, FormikValues } from 'formik';
import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import * as Yup from 'yup';

interface ICloseAccountField {
	reason: string;
}

const intlService: IntlService = Injector.get(IntlService);

const closeAccountSchema = Yup.object().shape<any>({
	reason: Yup.string().required(intlService.GetFormattedMessage('app.profile.user-info-form.close-account-validation')),
});

class CloseAccountComponent extends Component<models.ICloseAccountComponentProps, models.ICloseAccountComponentState> {
	private formRef = React.createRef<Formik<FormikValues>>();
	private CloseAccountField: ICloseAccountField = {
		reason: '',
	};

	public constructor(props: models.ICloseAccountComponentProps) {
		super(props);

		this.state = {
			loading: false,
			reason: '',
		};
	}
	public componentWillUnmount() {
		this.setState({ loading: false });
	}

	public render() {
		return (
			<CustomDialogBox
				open={this.props.openDialog}
				dialogTitle={this.props.intl.formatMessage({
					id: 'app.profile.user-info-form.close-account-dialog-box-title',
				})}
				dialogDescription={
					this.props.dialogDescription ??
					this.props.intl.formatMessage({
						id: 'app.profile.user-info-form.close.account-dialog-box-description',
					})
				}
				closeCustomDialog={this.closeDialog}
				fullWidth={true}
				submitButton={{
					isSubmit: true,
					isLoading: this.state.loading,
					onSubmit: () => this.formRef.current.submitForm(),
					isDisabled: this.state.loading,
				}}
				dialogYesButton={this.props.intl.formatMessage({
					id: 'app.profile.user-info-form.account-closed-button',
				})}
			>
				<>
					<Typography variant='body1'>
						{this.props.dialogDescription ??
							this.props.intl.formatMessage({
								id: 'app.profile.user-info-form.close.account-dialog-box-description',
							})}
					</Typography>
					<Formik
						initialValues={this.CloseAccountField}
						ref={this.formRef}
						onSubmit={async () => {
							try {
								this.setState({ loading: true });

								// Calling close account
								await this.props.onCloseAccount({ reason: this.state.reason });
							} catch (error) {
								this.setState({ loading: false });
								throw error;
							}
						}}
						validationSchema={closeAccountSchema}
						render={(props: FormikProps<FormikValues>) => (
							<Form noValidate={true}>
								<Field
									label={intlService.GetFormattedMessage('app.profile.user-info-form.close-account-label')}
									name='reason'
									margin='normal'
									variant='outlined'
									component={TextField}
									type='text'
									required={true}
									fullWidth={true}
									value={props.values.reason}
									onChange={(e: any) => {
										this.setState({
											reason: e.target.value,
										});
										props.handleChange('reason')(e);
									}}
									error={!!((props.values.reason.length || props.submitCount) && !!props.errors.reason)}
									helperText={props.values.reason.length || props.submitCount ? props.errors.reason : null}
								/>
							</Form>
						)}
					/>
				</>
			</CustomDialogBox>
		);
	}

	// close dialog
	private closeDialog = (dialogPanel: string, isCancel: boolean) => this.props.closeDialog(dialogPanel, isCancel);
}

export default injectIntl(CloseAccountComponent);



// WEBPACK FOOTER //
// ./src/components/shared/close-account.component.tsx